/**
 * Deletion Confirmed Page (Story 0.8 - GDPR)
 *
 * Shown after successfully initiating account deletion.
 * Uses green success styling (not red — the action succeeded).
 * No auth required (user is logged out at this point).
 *
 * AC: #6
 */

import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/deletion-confirmed")({
  component: DeletionConfirmedPage,
});

function DeletionConfirmedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center space-y-6">
        {/* Success icon */}
        <div className="mx-auto w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/20 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-8 w-8 text-green-600 dark:text-green-400"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-green-700 dark:text-green-400">
            Account Deletion Scheduled
          </h1>
          <p className="text-muted-foreground mt-2">
            Your account is scheduled for permanent deletion. You have a 14-day
            grace period to change your mind.
          </p>
        </div>

        <div className="rounded-md border bg-muted/50 p-4 text-sm text-left space-y-2">
          <p>
            <strong>Want to cancel?</strong> Simply log in before the deletion
            date and you'll see an option to cancel the deletion and restore your
            account.
          </p>
          <p>
            <strong>What happens next?</strong> After the grace period, your
            account and all associated data will be permanently deleted. You will
            receive a confirmation email once the process is complete.
          </p>
        </div>

        <Link
          to="/login"
          className="inline-block text-sm text-primary hover:underline"
        >
          Log in to cancel deletion
        </Link>
      </div>
    </div>
  );
}
